/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Divider,
  Flex,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Spacer,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import {
  Heading,
  useCQMediaQuery,
  usePaginationSessionStorage,
  useTabStorage,
  useBoolean
} from '@laxmimanogna/code-quick-components';
import React, { use, useContext, useEffect, useMemo, useState } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import { FONT_FAMILY } from '../../constants/Theme';
import MyAuditProvider, {
  MyAuditContext,
} from '../../providers/MyAuditProvider';
import RecentAudits from './components/RecentAudits';
import { withMultiProviders, withProvider } from '../../hoc/withProvider';
import AllAuditTable from './components/table/AllAuditTable';
import NewUploads from './components/table/NewUploads';
import ArchivedTable from './components/table/ArchivedTable';
import RebuttalTable from './components/table/RebuttalTable';
import Urgent from './components/table/Urgent';
import AppColors from '../../constants/AppColors';
import { SearchIcon, ChevronDownIcon, ChevronUpIcon, CloseIcon, RepeatIcon } from '@chakra-ui/icons';
import { UrgentIcon } from '../../constants/IconData';
import { CustomTab } from '../../components/CustomTab';
import NewAuditTable from './components/table/NewAuditTable';
import AuditSheetProvider, { AuditSheetContext } from '../../providers/AuditSheetProvider';
import { ChartFilterInfo, FILTER_OPTIONS, FILTER_OPTIONS_TO_CHART_STATUS_MAP } from '../../constants/constants';
import { DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME, DEFAULT_CHART_STATUS, getInitialStatusPosition } from './constants';
import { AuthContext } from '../../providers/AuthProvider';
import { CQUserType } from '../../utils/cqUserTypeUtils'

const DashboardContainerV2 = props => {
  // states
  const {
    getPaginationSession,
    setPaginationSession
  } = usePaginationSessionStorage();
  const tabStorage = useTabStorage();
  const [selectedTab, setSelectedTab] = useState(0);
  const DEFAULT_FILTER_NAME = useMemo(() => DEFAULT_CHART_STATUS, []);
  const DEFAULT_FILTER_POS = useMemo(() => FILTER_OPTIONS.indexOf(DEFAULT_FILTER_NAME), [DEFAULT_FILTER_NAME])
  const auditSheetContext = useContext(AuditSheetContext)
  const [resetFilterTrigger, rftState] = useBoolean(null);
  const [tableToggleData, setTableToggleData] = useState({
    expand:0,
    collapse:0
  })

  // other hooks
  const marginHorizontal = useCQMediaQuery({
    lg: '12%',
    md: '6%',
    sm: '2%',
  });

  // context
  const myAuditContext = useContext(MyAuditContext);
  const authContext = useContext(AuthContext)
  const {
    auditUrgentListCount,
    getRecentAudits,
    handleApplyFilter,
    filterParams,
    getAllCharts,
    isAllChartsLoading,
    myAuditsCheckbox,
    macState
  } = myAuditContext;

  const onSearchAction = (search = null) => {
    handleApplyFilter({
      ...filterParams,
      triggerSearch: !filterParams.triggerSearch,
    });
  };

  const onFilterChange = e => {
    handleApplyFilter({
      ...filterParams,
      searchText: e.target.value
    })
  };

  const isAdmin = authContext.currentUser.role === CQUserType.ADMIN;

  const onClearSearch = () => {
    handleApplyFilter({
      ...filterParams,
      searchText: '',
      triggerSearch: !filterParams.triggerSearch,
    });
  };

  const onStatusChange = option => {
    setSelectedFilter(option);
    handleApplyFilter({
      ...filterParams,
      triggerSearch: !filterParams.triggerSearch,
      chartStatusType: option.value
    });
  };

  const onToggleAssignedToMe = () => {
    getAllCharts.loadPageByFilterParams(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME, {'my_audits': !myAuditsCheckbox})
    macState.toggle();
  };

  

  const auditorPortalTabs = [
    {
      title: 'Charts',
      header: 'Charts',
      component: NewAuditTable,
    },
  ];

  // life-cycle hooks
  useEffect(() => {
    getRecentAudits();
  }, []);

  const dropdownOptions = useMemo(
    () => FILTER_OPTIONS.map(val => ({
      value: val,
      label: val,
      // ChartFilterInfo names don't always match exactly (e.g. "Rebuttal" vs "Rebuttals")
      description: ChartFilterInfo.find(
        info => info.name === val || `${info.name}s` === val
      )?.definition,
    })),
    []
  );

  const [selectedFilter, setSelectedFilter] = useState(() => ({
    value: FILTER_OPTIONS[getInitialStatusPosition(tabStorage, FILTER_OPTIONS)],
    label: FILTER_OPTIONS[getInitialStatusPosition(tabStorage, FILTER_OPTIONS)]
  }));

  useEffect(() => {
    if (!selectedFilter.value) {
      return;
    }
    tabStorage.setTab(FILTER_OPTIONS.indexOf(selectedFilter.value))
  }, [selectedFilter]);

  const onResetFilters = () => {
    macState.on();
    setSelectedFilter(dropdownOptions[DEFAULT_FILTER_POS]);
    setPaginationSession(
      DASHBOARD_PAGE_NAME,
      DASHBOARD_TABLE_NAME,
      {
        ...getPaginationSession(DASHBOARD_PAGE_NAME, DASHBOARD_TABLE_NAME),
        page: 1,
        size: 10
      }
    );
    handleApplyFilter({
      searchText: "",
      triggerSearch: !filterParams.triggerSearch,
      ordering: "",
      chartStatusType: DEFAULT_FILTER_NAME,
    });
    rftState.toggle();
  };

  const onOpenNotes = (obj, batchId, tabType = undefined) => {
    if (obj && Object.keys(obj).length) {
      if (obj.all) {
        delete auditSheetContext.commentFilters.sheet_name
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          page: 1,
          tabType: tabType
        })
      } else if (obj.current) {
        auditSheetContext.setCommentFilters({
          ...auditSheetContext.commentFilters,
          sheet_name: "Sheet1",
          page: 1,
          tabType: tabType
        })
      }
    } else {
      auditSheetContext.setCommentFilters({
        ...auditSheetContext.commentFilters,
        batchId,
        sheet_name: "Sheet1",
        reverse: true,
        page: 1,
        tabType: tabType
      })
    }
  }

  return (
    <Box>
      <Box py={5} height={250} bg={'white'} px={marginHorizontal}>
        <Heading
          fontSize={'24px'}
          fontFamily={FONT_FAMILY.baiJamurjee}
          fontWeight="bold"
        >
          Recent Audits
        </Heading>
        <RecentAudits />
      </Box>
      <CQContainer>
        <Heading my={5} fontSize={'xl'}>
          {auditorPortalTabs[selectedTab].header}
        </Heading>
        <Box
          shadow={'md'}
          bg="white"
          p={4}
          w="100%"
          style={{ borderRadius: '12px' }}
        >
          <Tabs
            fontFamily={FONT_FAMILY.baiJamurjee}
            onChange={setSelectedTab}
            index={selectedTab}
          >
            <Flex
              align={{ base: 'stretch', lg: 'center' }}
              direction={{ base: 'column', lg: 'row' }}
              gap={3}
              pb={4}
              mb={2}
              borderBottom="1px solid"
              borderColor="gray.200"
            >
              <HStack spacing={4}>
                {/* Status filter */}
                <Menu placement="bottom-start" isLazy>
                  <MenuButton
                    as={Button}
                    aria-label="Filter by chart status"
                    size="md"
                    variant="outline"
                    minW="200px"
                    textAlign="left"
                    fontWeight={500}
                    color="gray.700"
                    borderColor="gray.300"
                    rightIcon={<ChevronDownIcon />}
                    isLoading={isAllChartsLoading}
                    isDisabled={isAllChartsLoading}
                  >
                    {selectedFilter.label}
                  </MenuButton>
                  <MenuList zIndex={10} maxW="360px" py={1}>
                    <MenuOptionGroup
                      type="radio"
                      value={selectedFilter.value}
                      onChange={value => {
                        const option = dropdownOptions.find(o => o.value === value);
                        if (option && option.value !== selectedFilter.value) {
                          onStatusChange(option);
                        }
                      }}
                    >
                      {dropdownOptions.map(option => (
                        <MenuItemOption key={option.value} value={option.value} py={2}>
                          <Text fontSize="sm" fontWeight={600} color="gray.800">
                            {option.label}
                          </Text>
                          {option.description && (
                            <Text fontSize="xs" color="gray.500" mt={0.5}>
                              {option.description}
                            </Text>
                          )}
                        </MenuItemOption>
                      ))}
                    </MenuOptionGroup>
                  </MenuList>
                </Menu>

                {isAdmin && (
                  <Checkbox
                    size="md"
                    colorScheme="blue"
                    isChecked={myAuditsCheckbox}
                    onChange={onToggleAssignedToMe}
                    isDisabled={isAllChartsLoading}
                    whiteSpace="nowrap"
                  >
                    <Text fontSize="sm" fontWeight={500} color="gray.700">
                      Assigned to me
                    </Text>
                  </Checkbox>
                )}
              </HStack>

              <Spacer display={{ base: 'none', lg: 'block' }} />

              <HStack spacing={2}>
                {/* Row expand / collapse */}
                <ButtonGroup size="md" isAttached variant="outline">
                  <Tooltip label="Expand all rows" hasArrow openDelay={300}>
                    <IconButton
                      aria-label="Expand all rows"
                      icon={<ChevronDownIcon boxSize={5} />}
                      borderColor="gray.300"
                      color="gray.600"
                      onClick={() => setTableToggleData({
                        ...tableToggleData,
                        expand: tableToggleData.expand + 1})
                      }
                    />
                  </Tooltip>
                  <Tooltip label="Collapse all rows" hasArrow openDelay={300}>
                    <IconButton
                      aria-label="Collapse all rows"
                      icon={<ChevronUpIcon boxSize={5} />}
                      borderColor="gray.300"
                      color="gray.600"
                      onClick={() => setTableToggleData({
                        ...tableToggleData,
                        collapse: tableToggleData.collapse + 1})
                      }
                    />
                  </Tooltip>
                </ButtonGroup>

                <Divider orientation="vertical" h="24px" borderColor="gray.300" />

                {/* Search */}
                <InputGroup size="md" w={{ base: '100%', lg: '320px' }}>
                  <InputLeftElement pointerEvents="none">
                    <SearchIcon color="gray.400" />
                  </InputLeftElement>
                  <Input
                    value={filterParams?.searchText ?? ''}
                    onChange={onFilterChange}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        onSearchAction();
                      }
                    }}
                    placeholder="Search charts and press Enter"
                    borderRadius="md"
                    borderColor="gray.300"
                    focusBorderColor={AppColors.secondary}
                    isDisabled={isAllChartsLoading}
                  />
                  {filterParams?.searchText && (
                    <InputRightElement>
                      <IconButton
                        size="xs"
                        variant="ghost"
                        aria-label="Clear search"
                        icon={<CloseIcon boxSize={2.5} />}
                        onClick={onClearSearch}
                        isDisabled={isAllChartsLoading}
                      />
                    </InputRightElement>
                  )}
                </InputGroup>

                {/* Reset */}
                <Tooltip label="Back to default view: status, assigned to me, search, sorting and page" hasArrow openDelay={300}>
                  <Button
                    size="md"
                    variant="outline"
                    leftIcon={<RepeatIcon />}
                    fontWeight={500}
                    color="gray.700"
                    borderColor="gray.300"
                    flexShrink={0}
                    isDisabled={isAllChartsLoading}
                    onClick={onResetFilters}
                  >
                    Reset
                  </Button>
                </Tooltip>
              </HStack>
            </Flex>

            <TabPanels>
              {auditorPortalTabs.map((apt, i) => {
                return (
                  <TabPanel p={0} key={`assigned-audit-panel-${i}`}>
                    <apt.component 
                    key={`my-charts-panel-${i}`} 
                    onOpenNotes={onOpenNotes} 
                    PAGE_NAME={DASHBOARD_PAGE_NAME} 
                    TABLE_NAME={DASHBOARD_TABLE_NAME}
                    filterResetTrigger={resetFilterTrigger}
                    tableToggleData={tableToggleData}
                    />
                  </TabPanel>
                );
              })}
            </TabPanels>
          </Tabs>
        </Box>
      </CQContainer>
    </Box>
  );
};

export default withMultiProviders(
  [MyAuditProvider, AuditSheetProvider],
  DashboardContainerV2
);
